import { logError, log } from "../logging/Logger";

const googleTagManagerDataLayer = (window as any).dataLayer;

export function sendGTMData(payload: object) {
  if (googleTagManagerDataLayer) {
    try {
      googleTagManagerDataLayer.push(payload);
    } catch (error) {
      logError({ fn: "sendGTMData", error }, error.message);
    }
  }
}

export const track = (event: string): void => {
  if (!process.env.REACT_APP_TRACKING) {
    return;
  }
  // FB Pixel Tracking
  try {
    const windowFb = (window as any).fbq;
    if (windowFb) {
      windowFb("trackCustom", event);
      log({ fn: "track" }, "Successfully tracked FB event");
    } else {
      logError({ fn: "track" }, new Error("window.fbq is not found"));
    }
  } catch (error) {
    logError(
      {
        fn: "track",
        tracker: "FBQ",
        error,
      },
      error.message
    );
  }
  // GA Event Tracking
  try {
    // GA/GTM Event Tracking
    sendGTMData({
      event: event,
      category: event,
    });
  } catch (error) {
    logError(
      {
        fn: "track",
        tracker: "GA",
        error,
      },
      error.message
    );
  }
};
